/**
 * @module app.kya.list.sendContractCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function SendContractCtrl($scope, $uibModalInstance) {
        let self = {};

        // Sign modal
        self.dateSend = moment().format('DD/MM/YYYY');

        self.send = function() {
            $uibModalInstance.close({
                dateSend: self.dateSend
            });
        };

        self.cancel = function() {
            $uibModalInstance.dismiss('cancel');
        };

        return self;
    }

    SendContractCtrl.$inject = ['$scope', '$uibModalInstance'];

    angular.module('app.kya.list.sendContractCtrl', ['ui.bootstrap']).controller('SendContractCtrl', SendContractCtrl);
});
